'use client';

import { FulfillmentOptions, FulfillmentTile, InventoryStatus, SddDetails } from '../product-details';
import { MiniPdpBopisDetails } from './mini-pdp-bopis-details';
import type { MiniPdpFulfillmentProps } from './model/use-mini-pdp-fulfillment';
import { useMiniPdpFulfillment } from './model/use-mini-pdp-fulfillment';

export function MiniPdpFulfillment({
    product,
    tailored,
    isLoading,
    isError = false,
    onOpenSddAddress,
    onOpenStoreDrawer,
}: MiniPdpFulfillmentProps) {
    const { fulfillmentMethods, register, sddDetails, inventoryStatus } = useMiniPdpFulfillment({
        product,
        tailored,
        isLoading,
        isError,
        onOpenSddAddress,
    });

    return (
        <div className="mini-pdp-drawer__fulfillment">
            <FulfillmentOptions data-testid="mini-pdp-fulfillment-options">
                {fulfillmentMethods.map(method => (
                    <FulfillmentTile key={method.value} {...method} inputProps={register} />
                ))}
            </FulfillmentOptions>
            {sddDetails && <SddDetails {...sddDetails} className="delivery-details__container" />}
            <MiniPdpBopisDetails
                product={product}
                tailored={tailored}
                isLoading={isLoading}
                isError={isError}
                onOpenStoreDrawer={onOpenStoreDrawer}
            />
            {inventoryStatus && (
                <InventoryStatus
                    isLoading={inventoryStatus.isLoading}
                    label={inventoryStatus.label}
                    tone={inventoryStatus.tone}
                />
            )}
        </div>
    );
}
